import * as Styled from './Progress.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `Progress` atom renders a visual indicator of progress for a task or process.
 */
export const Progress = ({
  cssBackgroundColor = 'var(--computed-color__brand-primary--lightest)',
  cssProgressColor = 'var(--theme-color__brand-primary)',
  max,
  value,
  ...rest
}) => /*#__PURE__*/_jsx(Styled.Progress, {
  backgroundColor: cssBackgroundColor,
  progressColor: cssProgressColor,
  max: String(max),
  value: String(value),
  role: "progressbar",
  ...rest
});